// useCrewData.js — Phase 2: real snapshot via /api/crew-dashboard/snapshot, 60s poll + socket refresh.
import React from 'react';
import axios from 'axios';
import { simNow } from './crewFormat';
import { YARD } from './crewData';
import { subscribe } from '../../SocketIo/Socket';

const POLL_MS = 60000;
const EMPTY_FLEET = { crews: 0, membersOn: 0, onLunch: 0, onBreak: 0, driving: 0, ticketsDone: 0, ticketsSched: 0, behind: 0, otRisk: 0, otWill: 0, vehicleAlerts: 0, locationFlags: 0, idleHrs: 0, onsiteHrs: 0, healthy: 0, watch: 0, critical: 0 };

export function useCrewData(date) {
  const [data, setData] = React.useState({ crews: [], fleet: EMPTY_FLEET, meta: {} });
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const mounted = React.useRef(true);

  const load = React.useCallback(async () => {
    try {
      const params = date ? { date } : {};
      const res = await axios.get('/api/crew-dashboard/snapshot', { params });
      if (!mounted.current) return; // avoid setState after unmount (poll/socket can resolve late)
      setData({ crews: res.data.crews || [], fleet: res.data.fleet || EMPTY_FLEET, meta: res.data.meta || {} });
      setError(null);
    } catch (e) {
      if (mounted.current) setError(e);
    } finally {
      if (mounted.current) setLoading(false);
    }
  }, [date]);

  React.useEffect(() => {
    mounted.current = true;
    load();
    const id = setInterval(load, POLL_MS);
    return () => { mounted.current = false; clearInterval(id); };
  }, [load]);

  React.useEffect(() => {
    const unsub = subscribe('crew-dashboard:refresh', load);
    return () => { if (typeof unsub === 'function') unsub(); };
  }, [load]);

  return { crews: data.crews, fleet: data.fleet, meta: data.meta, yard: YARD, now: simNow, loading, error, source: 'live' };
}
